import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { ApiError } from "../../api/client";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof ApiError ? "Неверный email или пароль" : "Ошибка входа. Попробуйте снова.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gm-bg px-4">
      <form onSubmit={handleSubmit} className="w-full max-w-sm rounded-2xl border border-gm-border bg-gm-panel p-8 shadow-card-dark">
        <div className="flex items-center gap-2 text-xl font-extrabold text-gm-text">
          <span className="text-gm-gold">👑</span> GEO <span className="text-gm-gold">MASTER</span>
        </div>
        <p className="mt-1 text-sm text-gm-muted">Вход в панель управления</p>

        <label className="mt-6 block text-sm font-medium text-gm-muted">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 w-full rounded-xl border border-gm-border bg-gm-panel2 px-4 py-3 text-gm-text outline-none focus:border-gm-accent"
          placeholder="owner@geomaster.kz"
        />

        <label className="mt-4 block text-sm font-medium text-gm-muted">Пароль</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 w-full rounded-xl border border-gm-border bg-gm-panel2 px-4 py-3 text-gm-text outline-none focus:border-gm-accent"
          placeholder="••••••••"
        />

        {error && <p className="mt-3 text-sm font-medium text-gm-danger">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="mt-6 w-full rounded-xl bg-gm-accent py-3 font-bold text-white transition hover:brightness-110 disabled:opacity-50"
        >
          {loading ? "Входим…" : "Войти"}
        </button>
      </form>
    </div>
  );
}
